export const ICON_BLUE = 'blue';
export const INCOME_PROTECTION_KEY = 'incomeProtection';
export const RETIREMENT_KEY = 'retirement';
export const SAVINGS_KEY = 'savings';
export const BIG_INVESTMENT_PLAN_KEY = 'bigInvestmentPlan';
export const HEALTH_KEY = 'health';
export const GAUGE_CHART = 'gauge-chart';



// WEBPACK FOOTER //
// ./src/app/features/my-needs/constants.ts